import { useState } from "react";
import { Tab, Tabs, Typography, Box, Stack, Button } from "@mui/material";
import styled from "styled-components";
import AccountBoxOutlinedIcon from '@mui/icons-material/AccountBoxOutlined';
import FingerprintOutlinedIcon from '@mui/icons-material/FingerprintOutlined';
import ContactPageOutlinedIcon from '@mui/icons-material/ContactPageOutlined';
import DetailsForm from "./DetailsForm";
import NomineeDetailsAndBiometrics from "./NomineeDetailsBiometrics";
import BiometricsForm from "./BiometricsForm";
import { LoadingButton } from "@mui/lab";
import { useNavigate, useParams } from "react-router-dom";

const CustTab = styled(Tab)`
    opacity: ${(props: any): any => props.disabled ? "0.3" : "1"}
`;

const CustTypo = styled(Typography)`
    font-size: 14px !important;
    font-weitht: 700 !important;
    color: ${(props: any): any => props.selected ? "#3150A1" : "black"} !important;
    text-transform: capitalize !important;
`;
const CancelBtn = styled(Button)`
    margin: 10px !important;
    padding: 10px 20px !important;
    background: none !important;
    color: #EB5757 !important;
`;


const NewCustomerForm = ({ isAttorney, selectedCustomer, fetchData, isJoint }: { isJoint?: boolean, isAttorney?: boolean, selectedCustomer: any, fetchData: any }) => {

    const [value, setValue] = useState('one');
    const RenderForm = ({ value }: { value: string }) => {
        switch (value) {
            case "one":
                return <DetailsForm setPage={setValue} selectedCustomer={selectedCustomer} isAttorney={isAttorney} fetchData={fetchData} isJoint={isJoint} />
            case "two":
                return <BiometricsForm setPage={setValue} fetchData={fetchData} isAttorney={isAttorney}>
                    <FooterInfo />
                </BiometricsForm>
            case "three":
                return <NomineeDetailsAndBiometrics setPage={setValue}>
                    <FooterInfo />
                </NomineeDetailsAndBiometrics>
            default:
                return <></>
        }
    }

    return (
        <Stack spacing={4}>
            <FormTabs value={value} setValue={setValue} isAttorney={isAttorney} selectedCustomer={selectedCustomer} />
            <RenderForm value={value} />
        </Stack>
    );
}

const FormTabs = ({ value, setValue, isAttorney, selectedCustomer }: { selectedCustomer: any, value: string, setValue: (value: string) => void, isAttorney?: boolean }) => {

    const { id } = useParams()
    const handleChange = (event: React.SyntheticEvent, newValue: string) => {
        setValue(newValue);
    };


    return (
        <Box sx={{ width: '100%' }}>
            <Tabs
                value={value}
                onChange={handleChange}
                aria-label="Different forms link tabs for new registrations"
            >
                <Tab value="one" label={
                    <Stack direction="row" spacing={2}>
                        <CustTypo selected={value === "one"}><AccountBoxOutlinedIcon /></CustTypo>
                        <CustTypo selected={value === "one"}>Details</CustTypo>
                    </Stack>
                } />
                <CustTab disabled={id ? false : true} value="two" label={
                    <Stack direction="row" spacing={2}>
                        <CustTypo selected={value === "two"}><FingerprintOutlinedIcon /></CustTypo>
                        <CustTypo selected={value === "two"}>Biometrics</CustTypo>
                    </Stack>
                } />
                {
                    !isAttorney && <CustTab disabled={id ? false : true} value="three" label={
                        <Stack direction="row" spacing={2}>
                            <CustTypo selected={value === "three"}><ContactPageOutlinedIcon /></CustTypo>
                            <CustTypo selected={value === "three"} sx={{ flexGrow: "1" }}>Nominee Details</CustTypo>
                        </Stack>
                    } />
                }
            </Tabs>
        </Box>
    );
}



export default NewCustomerForm;

export const FooterInfo = ({ isEdit, loading }: { isEdit?: boolean, loading?: boolean }) => {
    const navigate = useNavigate();

    return (
        <Box sx={{ marginTop: '32px' }}>
            <Stack direction="row" spacing={2} sx={{ justifyContent: "space-between", height: '35px' }}>
                <CancelBtn>
                    <Typography onClick={() => navigate(-1)} sx={{ textTransform: "capitalize", fontSize: "14px" }}>Back</Typography>
                </CancelBtn>
                <LoadingButton
                    loading={loading}
                    type='submit'
                    variant='contained'
                    sx={{}}
                >
                    {isEdit ? "Update" : "Submit"}
                </LoadingButton>
            </Stack>
        </Box>
    );
}